// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"IntroductionSection_imageContainer__iQ8E_","container":"IntroductionSection_container__LBmRW","description":"IntroductionSection_description__Q4EAl"};